import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';

export const templates = {
  AlertView: 'AlertView',
};

export const sizes = {
  [templates.AlertView]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: 1280,
        h: 720,
      },
      [FULL_HD]: {
        w: 1920,
        h: 1080,
      },
    },
    [RENDERING_CONTEXT.SEARCH]: {
      [HD]: {
        w: 730,
        h: 572,
      },
      [FULL_HD]: {
        w: 1120,
        h: 865,
      },
    },
  },
};

export const imageOptions = {
  [templates.AlertView]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        width: 1280,
        height: 720,
      },
      [FULL_HD]: {
        width: 1920,
        height: 1080,
      },
    },
  },
};
